export var Sport;
(function (Sport) {
    Sport["Volleyball"] = "Volleyball";
    Sport["Basketball"] = "Basketball";
    Sport["Soccer"] = "Soccer";
    Sport["IceHockey"] = "IceHockey";
    Sport["Rugby"] = "Rugby";
    Sport["Baseball"] = "Baseball";
    Sport["Cricket"] = "Cricket";
})(Sport || (Sport = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3BvcnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc3BvcnRzL3Nwb3J0L3Nwb3J0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLEtBUVg7QUFSRCxXQUFZLEtBQUs7SUFDZixrQ0FBeUIsQ0FBQTtJQUN6QixrQ0FBeUIsQ0FBQTtJQUN6QiwwQkFBaUIsQ0FBQTtJQUNqQixnQ0FBdUIsQ0FBQTtJQUN2Qix3QkFBZSxDQUFBO0lBQ2YsOEJBQXFCLENBQUE7SUFDckIsNEJBQW1CLENBQUE7QUFDckIsQ0FBQyxFQVJXLEtBQUssS0FBTCxLQUFLLFFBUWhCIn0=